import { Component, inject, Input } from '@angular/core';

// Services
import { WsErrorService } from '../../../core/services/ws-error/ws-error.service';

@Component({
  selector: 'webservice-error',
  templateUrl: './webservice-error.component.html',
  styleUrls: ['../../../../styles/page.preset.scss'],
  standalone: false,
})
export class WebserviceErrorComponent {
  @Input() hasTrialExpired: boolean = false;

  public readonly wsError = inject(WsErrorService);

  get needToTranslate(): boolean {
    return this.wsError.needToTranslate;
  }

  toEmitRemoveWebServiceError(): void {
    this.wsError.removeWebServiceError();
  }
}
